/** @module api/remote */

import { apiCall } from '@/api/index'
import {
  apiV1EnergyManagementSystemMeterExchangeProtocolsPath,
  autoSearchApiV1EnergyManagementSystemMeterExchangeProtocolsPath,
  writeApiV1EnergyManagementSystemMeterExchangeProtocolsPath
} from '@/../lib/routes'

export function getMeterExchanges({ ctxt = 'technician', emsId }) {
  const payload = {}

  return apiCall({
    path: apiV1EnergyManagementSystemMeterExchangeProtocolsPath(ctxt, emsId),
    payload
  })
}

export function autoSearchMeterExchange({ ctxt = 'technician', emsId, leftT, rightT, sensorId }) {
  const payload = {
    filter: {
      sensorId,
      tFilter: {
        dateFrom: leftT,
        dateTo: rightT
      }
    }
  }
  return apiCall({
    path: autoSearchApiV1EnergyManagementSystemMeterExchangeProtocolsPath(ctxt, emsId),
    payload,
    timeout: 60000
  })
}

export function createMeterExchange({ ctxt = 'technician', emsId, left, right }) {
  const payload = createAddAtomicOperationsPayload([
    parseMeterExchangeToResource(left),
    parseMeterExchangeToResource(right)
  ])

  return apiCall({
    method: 'POST',
    path: writeApiV1EnergyManagementSystemMeterExchangeProtocolsPath(ctxt, emsId),
    payload,
    timeout: 60000
  })
}

export function deleteMeterExchangePair({ ctxt = 'technician', emsId, leftId, rightId }) {
  const payload = createRemoveAtomicOperationsPayload([leftId, rightId], 'meter_exchange_protocols')

  return apiCall({
    method: 'POST',
    path: writeApiV1EnergyManagementSystemMeterExchangeProtocolsPath(ctxt, emsId),
    payload,
    timeout: 60000
  })
}

const createAddAtomicOperationsPayload = (resources) => {
  const operations = []

  for (const resource of resources) {
    operations.push({
      op: 'add',
      data: resource
    })
  }

  return {
    'atomic:operations': operations
  }
}

const createRemoveAtomicOperationsPayload = (ids, type) => {
  const operations = []

  for (const id of ids) {
    operations.push({
      op: 'remove',
      ref: {
        id: id.toString(),
        type
      }
    })
  }

  return {
    'atomic:operations': operations
  }
}

const parseMeterExchangeToResource = (meterExchange) => {
  return {
    id: meterExchange.id > 0 ? meterExchange.id.toString() : null,
    type: 'meter_exchange_protocols',
    attributes: {
      isBegin: meterExchange.isBegin,
      t: meterExchange.t,
      val: meterExchange.val
    },
    relationships: {
      sensor: {
        data: {
          id: meterExchange.sensorId,
          type: 'sensors'
        }
      }
    }
  }
}
